import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[throttleClick]',
})
export class ThrottleClickDirective {
  @Input() throttleTime = 500;
  @Output() throttleClick = new EventEmitter<Event>();

  private isThrottled = false;

  @HostListener('click', ['$event'])
  handleClick(event: Event): void {
    if (this.isThrottled) {
      return;
    }

    this.throttleClick.emit(event);
    this.isThrottled = true;

    setTimeout(() => {
      this.isThrottled = false;
    }, this.throttleTime);
  }
}
